/**
 * ## jQueryAccordion module Usage
 *
 * ### Markup:
 * <dl class="accordion">
 *   <dt class="accordion__title"><a class="h5" href="#">Tab Title</a></dt>
 *   <dd class="accordion__content">Panel Content</dd>
 * </dl>
 *
 * ### JS:
 * $.fn.accordion = require('./jquery.accordion.js');
 * $('dl.accordion').accordion();
 */
/* globals jQuery */
export default (($) => {

    return function () {

        //VARIABLES
        const $tabs = $('dl.accordion dt');

        //FUNCTIONS
        const toggleAccPanelFn = function ($this_tab, $this_panel) {
            if ($this_tab.hasClass('active') && $this_panel.is(':visible')) {
                $this_panel.slideUp();
                $this_tab.removeClass('active').addClass('inactive');
            }
            else {
                $this_panel.slideDown();
                $this_tab.addClass('active').removeClass('inactive');
            }
        }

        //TAB ANCHOR CLICKS
        $tabs.find('a').on('click', function (e) {
            e.preventDefault();
            const this_tab = $(this).closest('dt');
            const this_panel = this_tab.next();

            toggleAccPanelFn(this_tab, this_panel);
        });
    }

})(jQuery)
